/*
 * roadmap.js -- filtr stavů v modulu „Plán vývoje" (08-12).
 *
 * CO DĚLÁ. Klik na `.th-rm-chip` uvnitř `[data-roadmap]` nechá viditelné jen
 * úkoly, jejichž `data-status` odpovídá `data-filter` chipu (`all` = všechny),
 * přepne `aria-pressed` na právě jednom chipu a schová celý rok, ve kterém po
 * filtru nezbyl ani jeden viditelný úkol.
 *
 * PROČ MODUL A NE INLINE `<script>`. Stará šablona tiskla přepínač jako
 * inline blok hned za markupem a hledala si kořen přes
 * `document.currentScript.previousElementSibling`. Nová šablona má inline
 * skripty omezené allowlistem s rozpočtem (kontrakt A4, gate
 * `scripts/lint-theme-2026.sh`) a jediný povolený globální namespace `TH2026`
 * (A7) -- přepínač proto patří do bundlu. Bonus: v bundlu je jednou bez
 * ohledu na počet modulů na stránce.
 *
 * VŠECHNY VÝSKYTY, NE JEN PRVNÍ. Stará verze se v jedné ze dvou větví
 * spoléhala na `document.querySelector('[data-roadmap]')`, takže druhý blok
 * na téže stránce by zůstal bez obsluhy (dnes se to nestane, protože
 * dispatcher roky seskupí -- ale seskupení přeruší jakýkoli jiný typ modulu
 * mezi nimi, a pak jsou bloky dva). `querySelectorAll` tu možnost odstraňuje
 * úplně.
 *
 * DELEGOVANÝ POSLUCHAČ NA KOŘENI BLOKU, ne na jednotlivých chipech: chipů je
 * proměnný počet (stav bez úkolů se nevykresluje) a jeden posluchač na blok
 * je levnější než N na tlačítka.
 *
 * BEZ SKRIPTU ZŮSTÁVÁ SEZNAM KOMPLETNÍ. Chipy vykresluje server a nic se
 * neskrývá dopředu, takže pád tohohle modulu bere JEN filtrování -- žádný
 * obsah (kontrakt B, D4). Skrývání jde přes atribut `hidden`, ne přes třídu:
 * `hidden` je nativní stav, který čtečka i vyhledávač znají bez CSS.
 */

/** Stavy, které dekodér pluginu umí vrátit -- žádný jiný filtr neexistuje. */
const STATES = ['all', 'done', 'prog', 'plan'];

function applyFilter(root, filter) {
	root.querySelectorAll('.th-rm-chip').forEach((chip) => {
		const on = chip.getAttribute('data-filter') === filter;

		chip.classList.toggle('is-on', on);
		chip.setAttribute('aria-pressed', on ? 'true' : 'false');
	});

	root.querySelectorAll('.th-rm-task').forEach((task) => {
		task.hidden = !(filter === 'all' || task.getAttribute('data-status') === filter);
	});

	/* Rok, ve kterém po filtru nezbyl žádný úkol, se schová celý. */
	root.querySelectorAll('.th-rm-year').forEach((year) => {
		year.hidden = year.querySelectorAll('.th-rm-task:not([hidden])').length === 0;
	});
}

function onClick(event) {
	const chip = event.target.closest ? event.target.closest('.th-rm-chip') : null;

	if (!chip) {
		return;
	}

	const root = chip.closest('[data-roadmap]');

	if (!root) {
		return;
	}

	const filter = chip.getAttribute('data-filter') || '';

	/*
	 * Neznámá hodnota se ignoruje MÍSTO toho, aby schovala všechno.
	 * Chip s překlepem v atributu by jinak vyrobil prázdnou stránku --
	 * a to je horší než filtr, který nic neudělá.
	 */
	if (STATES.indexOf(filter) < 0) {
		return;
	}

	applyFilter(root, filter);
}

export function init() {
	const roots = document.querySelectorAll('[data-roadmap]');

	if (!roots.length) {
		return;
	}

	roots.forEach((root) => {
		root.addEventListener('click', onClick);
	});
}
